module.exports = __webpack_public_path__ + "viber-logo.f0e9a08de953afd48bb3.png";


//////////////////
// WEBPACK FOOTER
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/img/viber-logo.png
// module id = ../../../../../src/img/viber-logo.png
// module chunks = 5